import { render, staticRenderFns } from "./custom-bread-crumb.vue?vue&type=template&id=5ae58cec&"
import script from "./custom-bread-crumb.vue?vue&type=script&lang=js&"
export * from "./custom-bread-crumb.vue?vue&type=script&lang=js&"
import style0 from "./custom-bread-crumb.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports